<div class="stats-and-reports">
  <div class="row">
    <div class="col-md-3">
      <hr-stats-and-reports-announcements
        [channelAnnouncementStats]="
          adminStatsAndReports?.channelAnnouncementStats
        "
      ></hr-stats-and-reports-announcements>
    </div>
    <div class="col-md-3">
      <hr-stats-and-reports-customers
        [customerStats]="adminStatsAndReports?.customerStats"
      ></hr-stats-and-reports-customers>
    </div>
    <div class="col-md-3">
      <hr-stats-and-reports-jobseekers
        [channelJobseekerStats]="adminStatsAndReports?.channelJobseekerStats"
      ></hr-stats-and-reports-jobseekers>
    </div>
    <div class="col-md-3">
      <hr-stats-and-reports-subscribers
        [channelSubscriberStats]="adminStatsAndReports?.channelSubscriberStats"
      ></hr-stats-and-reports-subscribers>
    </div>
  </div>
</div>
<div style="margin-top: 1em">
  <a [routerLink]="['/stats-and-reports/matching-announcements']">Matching</a>
</div>
<div style="margin-top: 1em">
  <a [routerLink]="['/stats-and-reports/sales-report']">Sales report</a>
</div>
<div *ngIf="hasMonthlyPlanReportViewPermission" style="margin-top: 1em">
  <a [routerLink]="['/sales/monthly-plan-report']">{{
    'label.SalesTargetsReport' | translate
  }}</a>
</div>
<div *ngIf="hasMonthlyPlanEnterPermission" style="margin-top: 1em">
  <a [routerLink]="['/sales/monthly-plan']">{{
    'label.EnterSalesTargets' | translate
  }}</a>
</div>
<div style="margin-top: 1em">
  <a [routerLink]="['/stats-and-reports/cv-database-report']"
    >Cv Database report</a
  >
</div>
<div style="margin-top: 1em">
  <a [routerLink]="['/stats-and-reports/messaging-report']">Suspended emails</a>
</div>
<div style="margin-top: 1em">
  <a [routerLink]="['/stats-and-reports/indexation-report']"
    >Indexation Report</a
  >
</div>
<div style="margin-top: 1em">
  <p *ngFor="let item of adminStatsAndReports.eventsReport">
    {{ item.eventName }}: Visitors - {{ item.visitors }}, Applications -
    {{ item.applications }}
  </p>
</div>
